import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useRef, type FC } from "react";
import { faCog } from "@fortawesome/pro-solid-svg-icons";
import { animate, AnimatePresence, motion, useMotionValue } from "motion/react";
import { useDevice, useWindowSize } from "~/client/hooks";
import { NavButton } from "../../buttons";
import { Swipeable, type TouchEndParams, type TouchMoveParams, type TouchStartParams } from "../../interactives";
import "./styles.scss";
import { bem } from "./styles";
interface DrawerNavProps {
  readonly isOpen: boolean;
  readonly setIsOpen: Dispatch<SetStateAction<boolean>>;
}
export const DrawerNav: FC<DrawerNavProps> = t0 => {
  const $ = _c(22);
  const {
    isOpen,
    setIsOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "spring",
      stiffness: 300,
      damping: 35
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const animationOptions = t1 as const;
  const device = useDevice();
  const x = useMotionValue(250);
  const ref = useRef(null);
  const {
    width
  } = useWindowSize();
  let t2;
  if ($[1] !== setIsOpen) {
    t2 = () => setIsOpen(false);
    $[1] = setIsOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  let t3;
  if ($[3] !== isOpen || $[4] !== x) {
    t3 = t4 => {
      const {
        startX
      } = t4;
      if (!startX) {
        x.set(isOpen ? 0 : 250);
      }
    };
    $[3] = isOpen;
    $[4] = x;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTouchStart = t3;
  let t4;
  if ($[6] !== x) {
    t4 = t5 => {
      const {
        deltaX
      } = t5;
      if (deltaX < 0 || deltaX > 250) {
        return;
      }
      x.set(deltaX);
    };
    $[6] = x;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleTouchMove = t4;
  let t5;
  if ($[8] !== device.type || $[9] !== setIsOpen || $[10] !== width || $[11] !== x) {
    t5 = t6 => {
      const {
        deltaX: deltaX_0,
        duration
      } = t6;
      const maxSwipeDistance = device.type === "tablet" ? 120 : 100;
      const swipeThreshold = Math.min(width * 0.25, maxSwipeDistance);
      const exceedsThreshold = deltaX_0 > swipeThreshold;
      const velocity = Math.abs(deltaX_0) / duration;
      const exceedsVelocity = velocity > 0.3;
      const currentPosition = x.get();
      const draggedPastMidpoint = currentPosition > 125;
      if (exceedsThreshold || exceedsVelocity || draggedPastMidpoint) {
        setIsOpen(false);
      } else {
        animate(x, 0, animationOptions);
      }
    };
    $[8] = device.type;
    $[9] = setIsOpen;
    $[10] = width;
    $[11] = x;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleTouchEnd = t5;
  let t6;
  if ($[13] !== handleClose || $[14] !== handleTouchEnd || $[15] !== handleTouchMove || $[16] !== handleTouchStart || $[17] !== isOpen || $[18] !== x) {
    t6 = isOpen && <Swipeable onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onClick={handleClose} className={bem()}><motion.div ref={ref} className={bem("content")} style={{
        x
      }} initial={{
        x: 250
      }} animate={{
        x: 0
      }} exit={{
        x: 250
      }} transition={animationOptions} onClick={_temp}><div><NavButton icon={faCog} text="Settings" href="/settings/profile" /></div></motion.div></Swipeable>;
    $[13] = handleClose;
    $[14] = handleTouchEnd;
    $[15] = handleTouchMove;
    $[16] = handleTouchStart;
    $[17] = isOpen;
    $[18] = x;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <AnimatePresence>{t6}</AnimatePresence>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
function _temp(e) {
  return e.stopPropagation();
}